import { logAPI } from "../andyliticsApi";
const webTpaApiUrl = typeof window !== 'undefined' ? window.serverData.data.webTPAUrl : ''; // window is undefined during pre-render
// this needs to be loaded dynamically (since it will change after startup)
//const hpServicesUrl = typeof window !== 'undefined' ? (window.serverData.data.hpServicesSpecificUrl ? window.serverData.data.hpServicesSpecificUrl : window.serverData.data.hpServicesUrl) : ''; // window is undefined during pre-render
import * as tools from "../../helpers/Tools";

export const getInvoicesList = (token, subscriptionHccId, fromDate, toDate) => {
    const url = encodeURI( tools.buildUrl( tools.hpAPIBaseURL(), '/invoices/getinvoicesbydate/'));

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            subscriptionHccId: subscriptionHccId,
            FromDate: fromDate,
            ToDate: toDate,
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Invoices.GettInvoicesList", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Invoices.GetInvoicesList.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getInvoiceDetails = (token, invoiceId) => {
    const url = encodeURI( tools.buildUrl( tools.hpAPIBaseURL(), '/invoices/details'));

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            InvoiceNumber: invoiceId,
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Invoices.GettInvoiceDetails", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Invoices.GettInvoiceDetails.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getInvoiceAdjustments = (token, invoiceId) => {
    const url = encodeURI( tools.buildUrl( tools.hpAPIBaseURL(), '/invoices/details/adjustments'));

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            InvoiceNumber: invoiceId,
        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Invoices.GetInvoiceAdjustments", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Invoices.GetInvoiceAdjustments.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getDentalInvoiceDetails = (token, memberId) => {

    let oState = window.store.getState();
    let prefix = oState.domain.pre ? oState.domain.pre : "AMI"; //this will only be called for AMISYS users
    let baseURL = tools.ciReplace(window.serverData.data.hpGatewayUrl, "WTPA", prefix);
    const url = encodeURI(tools.buildUrl(baseURL, '/members/dental/invoicedetails'));

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memid: memberId,
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Dental.GetDentalInvoiceDetails", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Dental.GetDentalInvoiceDetails", start, url, err); return Promise.reject(err);
    });
};